import type { IAccountLenderAccreditation } from './AccountLenderAccreditation.interface';

export default class AccountLenderAccreditation implements IAccountLenderAccreditation {
  id: string;
  idLender: string;
  brokerIdPrimary: string;
  brokerIdSecondary: string;
  additionalInformation: string;
  upfront: string;
  trail: string;
  notes: string;

  static build = (data: IAccountLenderAccreditation) => new AccountLenderAccreditation(data);
  static blank = () => new AccountLenderAccreditation();

  /**
   * Constructor
   * @param {IAccountLenderAccreditation} data
   */
  constructor(data?: IAccountLenderAccreditation) {
    this.id = data?.id || '';
    this.idLender = data?.idLender || '';
    this.brokerIdPrimary = data?.brokerIdPrimary || undefined;
    this.brokerIdSecondary = data?.brokerIdSecondary || undefined;
    this.additionalInformation = data?.additionalInformation || undefined;
    this.upfront = data?.upfront || undefined;
    this.trail = data?.trail || undefined;
    this.notes = data?.notes || undefined;
  }
}
